import React, { useState, useEffect } from "react";
import MainCalculatorsList from "../OtherCalculator/CountriesMainCalculatorsList/SAMainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "حاسبة نقاط ترقية الكادر الإداري 2026 - وزارة التعليم السعودية";
const DESCRIPTION =
  "احسب نقاطك للترقية وفق معايير وزارة التعليم السعودية 2026 للكادر الإداري. تشمل تقييم الأداء الوظيفي والتدريب والتطوير وساعات التطوع أو اختبار الكفايات القيادية.";
const KEYWORDS =
  "حاسبة ترقية الكادر الإداري, نقاط الترقية, وزارة التعليم السعودية, معايير الترقية 2026, تقييم الأداء الوظيفي, التدريب والتطوير, العمل التطوعي, اختبار قياس, الكفايات القيادية";
const OG_URL =
  "https://do-calculate.com/calculator/ar/countries/SA/calculators-list/admin-promotion-calculator/";

const TRAINING_WEIGHTS = {
  selfLearning: 2.5,
  hrDev: 12.5,
  ipaShort: 12.5,
  ipaExam: 25,
  ipaWorkshop: 12.5,
  cert1: 50,
  cert2: 25,
  cert3: 12.5,
};

function AdminPromotionCalculator() {
  const [gradeType, setGradeType] = useState("grade10below");
  const [performanceRating, setPerformanceRating] = useState("");
  const [selfLearning, setSelfLearning] = useState("");
  const [hrDev, setHrDev] = useState("");
  const [ipaShort, setIpaShort] = useState("");
  const [ipaExam, setIpaExam] = useState("");
  const [ipaWorkshop, setIpaWorkshop] = useState("");
  const [cert1, setCert1] = useState("");
  const [cert2, setCert2] = useState("");
  const [cert3, setCert3] = useState("");
  const [volunteerHours, setVolunteerHours] = useState("");
  const [examScore, setExamScore] = useState("");
  const [result, setResult] = useState(null);

  const handleReset = () => {
    setGradeType("grade10below");
    setPerformanceRating("");
    setSelfLearning("");
    setHrDev("");
    setIpaShort("");
    setIpaExam("");
    setIpaWorkshop("");
    setCert1("");
    setCert2("");
    setCert3("");
    setVolunteerHours("");
    setExamScore("");
  };

  const isGrade10Below = gradeType === "grade10below";

  useEffect(() => {
    const rating = Number(performanceRating);
    if (!performanceRating || ![3, 4, 5].includes(rating)) {
      setResult(null);
      return;
    }

    const performancePct = rating === 5 ? 100 : rating === 4 ? 80 : 60;
    const performancePoints = (performancePct / 100) * 30;

    const sl = Math.max(0, Number(selfLearning) || 0);
    const hd = Math.max(0, Number(hrDev) || 0);
    const is_ = Math.max(0, Number(ipaShort) || 0);
    const ie = Math.max(0, Number(ipaExam) || 0);
    const iw = Math.max(0, Number(ipaWorkshop) || 0);
    const c1 = Math.max(0, Number(cert1) || 0);
    const c2 = Math.max(0, Number(cert2) || 0);
    const c3 = Math.max(0, Number(cert3) || 0);

    const trainingRawPct =
      sl * TRAINING_WEIGHTS.selfLearning +
      hd * TRAINING_WEIGHTS.hrDev +
      is_ * TRAINING_WEIGHTS.ipaShort +
      ie * TRAINING_WEIGHTS.ipaExam +
      iw * TRAINING_WEIGHTS.ipaWorkshop +
      c1 * TRAINING_WEIGHTS.cert1 +
      c2 * TRAINING_WEIGHTS.cert2 +
      c3 * TRAINING_WEIGHTS.cert3;

    const trainingCappedPct = Math.min(trainingRawPct, 100);
    const trainingPoints = (trainingCappedPct / 100) * 40;

    let criterion3Points = 0;
    let volunteerInfo = null;
    let examInfo = null;

    if (isGrade10Below) {
      const hours = Math.max(0, Number(volunteerHours) || 0);
      const cappedHours = Math.min(hours, 30);
      criterion3Points = (cappedHours / 30) * 30;
      const hoursNeeded = Math.max(0, 30 - hours);
      volunteerInfo = { hours, cappedHours, hoursNeeded };
    } else {
      const score = Math.min(100, Math.max(0, Number(examScore) || 0));
      criterion3Points = (score / 100) * 30;
      examInfo = { score };
    }

    const total = performancePoints + trainingPoints + criterion3Points;

    setResult({
      total: total.toFixed(1),
      performancePoints: performancePoints.toFixed(1),
      performancePct,
      trainingPoints: trainingPoints.toFixed(1),
      trainingCappedPct: trainingCappedPct.toFixed(1),
      trainingRawPct: trainingRawPct.toFixed(1),
      criterion3Points: criterion3Points.toFixed(1),
      volunteerInfo,
      examInfo,
    });
  }, [
    gradeType, performanceRating,
    selfLearning, hrDev, ipaShort, ipaExam, ipaWorkshop,
    cert1, cert2, cert3,
    volunteerHours, examScore,
    isGrade10Below,
  ]);

  return (
    <div className="rtl" style={{ direction: "rtl" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "5px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                <strong>حاسبة نقاط ترقية الكادر الإداري</strong> أداة مجانية مُصممة لموظفي وزارة
                التعليم السعودية، تحسب نقاطك للترقية وفق المعايير الرسمية لعام 2026م. يشمل التقييم
                ثلاثة محاور: الأداء الوظيفي (30%)، وبرامج التدريب والتطوير (40%)، والمعيار الثالث
                الذي يختلف بحسب المرتبة. النتيجة تظهر فوراً كلما غيّرت أي قيمة.{" "}
                <a
                  href="https://www.moe.gov.sa/ar/aboutus/sectors/hr/Documents/987788888%D9%85%20%D8%AF.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  📄 الوثيقة الرسمية لوزارة التعليم
                </a>
              </p>
            </div>
            <hr />
            <MobileUnderCalAds />

            <div className="calculatorStyle mb-4">
              <div className="p-3 mb-3 bg-success text-white text-center rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>
                  احسب نقاط الترقية — خاص بموظفي وزارة التعليم السعودية
                </h2>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <label htmlFor="gradeType">نوع المرتبة الحالية</label>
                  <select
                    id="gradeType"
                    className="form-select"
                    value={gradeType}
                    onChange={(e) => { setGradeType(e.target.value); setResult(null); }}
                  >
                    <option value="grade10below">المرتبة العاشرة فما دون</option>
                    <option value="grade11to13">المرتبة الحادية عشرة حتى الثالثة عشرة (11-12-13)</option>
                  </select>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <label htmlFor="performanceRating">
                    الأداء الوظيفي (30%) — نتيجة التقييم السنوي الأخير
                  </label>
                  <select
                    id="performanceRating"
                    className="form-select"
                    value={performanceRating}
                    onChange={(e) => setPerformanceRating(e.target.value)}
                  >
                    <option value="">-- اختر نتيجة التقييم --</option>
                    <option value="5">5 (ممتاز) — 100% من وزن المعيار = 30 نقطة</option>
                    <option value="4">4 (جيد جداً) — 80% من وزن المعيار = 24 نقطة</option>
                    <option value="3">3 (جيد) — 60% من وزن المعيار = 18 نقطة</option>
                  </select>
                </div>
              </div>

              {isGrade10Below ? (
                <div className="row">
                  <div className="col-sm-12">
                    <label htmlFor="volunteerHours">
                      ساعات التطوع (30%) — الحد الأعلى 30 ساعة عبر المنصات الوطنية
                    </label>
                    <input
                      id="volunteerHours"
                      type="number"
                      min="0"
                      max="30"
                      className="form-control"
                      placeholder="أدخل عدد ساعات التطوع"
                      value={volunteerHours}
                      onChange={(e) => setVolunteerHours(e.target.value)}
                    />
                  </div>
                </div>
              ) : (
                <div className="row">
                  <div className="col-sm-12">
                    <label htmlFor="examScore">
                      درجة اختبار الكفايات القيادية - قياس (30%) — من 100
                    </label>
                    <input
                      id="examScore"
                      type="number"
                      min="0"
                      max="100"
                      className="form-control"
                      placeholder="أدخل درجة اختبار قياس"
                      value={examScore}
                      onChange={(e) => setExamScore(e.target.value)}
                    />
                  </div>
                </div>
              )}

              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <label>إثرائي / دروب / أبعاد / سماي <small className="text-muted">(2.5% للدورة)</small></label>
                  <input type="number" min="0" className="form-control" placeholder="عدد الدورات"
                    value={selfLearning} onChange={(e) => setSelfLearning(e.target.value)} />
                </div>
                <div className="col-sm-12 col-md-6">
                  <label>برامج وكالة الموارد البشرية <small className="text-muted">(12.5% للبرنامج)</small></label>
                  <input type="number" min="0" className="form-control" placeholder="عدد البرامج"
                    value={hrDev} onChange={(e) => setHrDev(e.target.value)} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <label>معهد الإدارة العامة (قصير) <small className="text-muted">(12.5% للبرنامج)</small></label>
                  <input type="number" min="0" className="form-control" placeholder="عدد البرامج"
                    value={ipaShort} onChange={(e) => setIpaShort(e.target.value)} />
                </div>
                <div className="col-sm-12 col-md-6">
                  <label>معهد الإدارة (باجتياز اختبار) <small className="text-muted">(25% للبرنامج)</small></label>
                  <input type="number" min="0" className="form-control" placeholder="عدد البرامج"
                    value={ipaExam} onChange={(e) => setIpaExam(e.target.value)} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <label>الحلقات التطبيقية من معهد الإدارة <small className="text-muted">(12.5% للحلقة)</small></label>
                  <input type="number" min="0" className="form-control" placeholder="عدد الحلقات"
                    value={ipaWorkshop} onChange={(e) => setIpaWorkshop(e.target.value)} />
                </div>
                <div className="col-sm-12 col-md-6">
                  <label>شهادات مهنية مستوى 1 <small className="text-muted">(50% للشهادة)</small></label>
                  <input type="number" min="0" className="form-control" placeholder="عدد الشهادات"
                    value={cert1} onChange={(e) => setCert1(e.target.value)} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <label>شهادات مهنية مستوى 2 <small className="text-muted">(25% للشهادة)</small></label>
                  <input type="number" min="0" className="form-control" placeholder="عدد الشهادات"
                    value={cert2} onChange={(e) => setCert2(e.target.value)} />
                </div>
                <div className="col-sm-12 col-md-6">
                  <label>شهادات مهنية مستوى 3 <small className="text-muted">(12.5% للشهادة)</small></label>
                  <input type="number" min="0" className="form-control" placeholder="عدد الشهادات"
                    value={cert3} onChange={(e) => setCert3(e.target.value)} />
                </div>
              </div>

              <div className="text-center mb-3 mt-4">
                <button
                  onClick={handleReset}
                  className="btn btn-secondary"
                  style={{ fontSize: "16px", padding: "10px 30px" }}
                >
                  امسح
                </button>
              </div>

              {result && (
                <div className="mt-4">
                  <h3 style={{ fontSize: "18px", marginBottom: "15px", textAlign: "center" }}>
                    <strong>النتيجة:</strong>
                  </h3>
                  <div className="mb-3">
                    <table className="table bmi-table" style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th className="bmi-header" style={{ textAlign: "center" }}>المعيار</th>
                          <th className="bmi-header" style={{ textAlign: "center" }}>النقاط</th>
                          <th className="bmi-header" style={{ textAlign: "center" }}>من</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ textAlign: "center" }}>الأداء الوظيفي ({result.performancePct}%)</td>
                          <td style={{ textAlign: "center", fontSize: "18px", fontWeight: "bold", color: "#1a5f3f" }}>
                            {result.performancePoints}
                          </td>
                          <td style={{ textAlign: "center" }}>30</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>
                            {isGrade10Below
                              ? `التطوع (${result.volunteerInfo.cappedHours}/30 ساعة)`
                              : `اختبار قياس (${result.examInfo.score}/100)`}
                          </td>
                          <td style={{ textAlign: "center", fontSize: "18px", fontWeight: "bold", color: "#1a5f3f" }}>
                            {result.criterion3Points}
                          </td>
                          <td style={{ textAlign: "center" }}>30</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>
                            التدريب والتطوير ({result.trainingCappedPct}%)
                            {parseFloat(result.trainingRawPct) > 100 && (
                              <small className="text-muted"> — تم تطبيق الحد الأعلى</small>
                            )}
                          </td>
                          <td style={{ textAlign: "center", fontSize: "18px", fontWeight: "bold", color: "#1a5f3f" }}>
                            {result.trainingPoints}
                          </td>
                          <td style={{ textAlign: "center" }}>40</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}><strong>المجموع الكلي</strong></td>
                          <td style={{ textAlign: "center", fontSize: "22px", fontWeight: "bold", color: "#0f3d28" }}>
                            {result.total}
                          </td>
                          <td style={{ textAlign: "center" }}><strong>100</strong></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="info-sections-container">
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>ملخص النتيجة</strong>
                      </div>
                      <div className="info-section-body">
                        <ul style={{ listStyle: "none", padding: 0, lineHeight: "2" }}>
                          {isGrade10Below && (
                            <li>
                              {result.volunteerInfo.hoursNeeded > 0
                                ? `⏳ التطوع ناقص: تحتاج ${result.volunteerInfo.hoursNeeded} ساعة إضافية`
                                : "✅ التطوع: مكتمل (30/30)"}
                            </li>
                          )}
                          <li>
                            {parseFloat(result.trainingCappedPct) >= 100
                              ? "✅ التدريب: مكتمل (40/40)"
                              : `📚 التدريب: يمكنك تحقيق ${(40 - parseFloat(result.trainingPoints)).toFixed(1)} نقطة إضافية`}
                          </li>
                        </ul>
                        <div className="alert alert-info mt-3" style={{ fontSize: "14px" }}>
                          <strong>💡 ملاحظة:</strong> عند تساوي النقاط تُطبّق عناصر الترجيح بالترتيب المحدد في الوثيقة الرسمية.
                        </div>
                      </div>
                    </div>
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>تفاصيل الحساب</strong>
                      </div>
                      <div className="info-section-body">
                        <div style={{ lineHeight: "1.8" }}>
                          <p><strong>نوع المرتبة:</strong> {isGrade10Below ? "العاشرة فما دون" : "11-12-13"}</p>
                          <p>
                            <strong>الأداء الوظيفي:</strong> تقييم {performanceRating} →{" "}
                            {result.performancePct}% × 30 = {result.performancePoints} نقطة
                          </p>
                          <p>
                            <strong>{isGrade10Below ? "التطوع:" : "اختبار قياس:"}</strong>{" "}
                            {isGrade10Below
                              ? `${result.volunteerInfo.cappedHours}/30 × 30 = ${result.criterion3Points} نقطة`
                              : `${result.examInfo.score}/100 × 30 = ${result.criterion3Points} نقطة`}
                          </p>
                          <p>
                            <strong>التدريب:</strong> {result.trainingRawPct}% (مقيّد بـ 100%) × 40 ={" "}
                            {result.trainingPoints} نقطة
                          </p>
                          <hr />
                          <p style={{ fontSize: "14px", color: "#666" }}>
                            <strong>المجموع = </strong>
                            {result.performancePoints} + {result.criterion3Points} + {result.trainingPoints}{" "}
                            = <strong>{result.total} / 100</strong>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>

        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>

      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">

            <div className="info-section">
              <div className="info-section-header">
                <strong>كيفية استخدام حاسبة نقاط الترقية</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>حاسبة نقاط ترقية الكادر الإداري</strong> تحسب نقاطك تلقائياً فور إدخال
                  أي قيمة دون الحاجة للضغط على أي زر. المعايير الثلاثة مأخوذة مباشرة من الوثيقة
                  الرسمية لوزارة التعليم 2026م.
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>خطوات الاستخدام:</h3>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>اختر نوع مرتبتك الحالية (العاشرة فما دون، أو 11-12-13)</li>
                  <li>اختر نتيجة تقييم الأداء الوظيفي الأخير من نظام فارس</li>
                  <li>أدخل عدد ساعات التطوع (للمرتبة 10 فما دون) أو درجة اختبار قياس (للمرتبة 11-13)</li>
                  <li>أدخل عدد برامج التدريب والشهادات المهنية في كل خانة</li>
                  <li>تظهر النتيجة تلقائياً مع تفاصيل كل معيار</li>
                </ol>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <strong>المعيار الأول: تقييم الأداء الوظيفي (30%)</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  تُحدد النقاط بناءً على نتيجة التقييم السنوي الأخير في نظام فارس:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>التقييم 5 (ممتاز): 100% من وزن المعيار = <strong>30 نقطة</strong></li>
                  <li>التقييم 4 (جيد جداً): 80% من وزن المعيار = <strong>24 نقطة</strong></li>
                  <li>التقييم 3 (جيد): 60% من وزن المعيار = <strong>18 نقطة</strong></li>
                </ul>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <strong>المعيار الثاني: برامج التطوير والتدريب (40%)</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  يحتسب لكل نوع من البرامج نسبة من وزن المعيار (40%)، والحد الأقصى للمجموع 100% أي 40 نقطة.
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>دورات إثرائي / دروب / أبعاد / سماي: <strong>2.5% للدورة</strong> (= 1 نقطة)</li>
                  <li>برامج وكالة الموارد البشرية: <strong>12.5% للبرنامج</strong> (= 5 نقاط)</li>
                  <li>معهد الإدارة العامة (قصير): <strong>12.5% للبرنامج</strong> (= 5 نقاط)</li>
                  <li>معهد الإدارة العامة (باجتياز اختبار): <strong>25% للبرنامج</strong> (= 10 نقاط)</li>
                  <li>الحلقات التطبيقية من معهد الإدارة: <strong>12.5% للحلقة</strong> (= 5 نقاط)</li>
                  <li>شهادات مهنية مستوى 1: <strong>50% للشهادة</strong> (= 20 نقطة)</li>
                  <li>شهادات مهنية مستوى 2: <strong>25% للشهادة</strong> (= 10 نقاط)</li>
                  <li>شهادات مهنية مستوى 3: <strong>12.5% للشهادة</strong> (= 5 نقاط)</li>
                </ul>
                <div className="alert alert-info mt-3" style={{ lineHeight: "1.8" }}>
                  <strong>💡 مثال:</strong> موظف لديه 4 دورات إثرائي + برنامجان معهد الإدارة (قصير) + شهادة مستوى 2:
                  (4×2.5) + (2×12.5) + (1×25) = 10 + 25 + 25 = 60% → 24 نقطة
                </div>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <strong>المعيار الثالث: التطوع أو اختبار قياس (30%)</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>للمرتبة العاشرة فما دون — ساعات التطوع:</h3>
                <p style={{ lineHeight: "1.8" }}>
                  يُحتسب عبر المنصات الوطنية المعتمدة بحد أقصى 30 ساعة.
                  النقاط = (عدد الساعات ÷ 30) × 30. للتسجيل:{" "}
                  <a href="https://nvg.gov.sa/" target="_blank" rel="noopener noreferrer">nvg.gov.sa</a>{" "}
                  أو التطوع الصحي عبر الهلال الأحمر السعودي.
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>للمرتبة 11-12-13 — اختبار الكفايات القيادية (قياس):</h3>
                <p style={{ lineHeight: "1.8" }}>
                  تُحتسب الدرجة من 100 بنسبة وزن المعيار. صالحية الاختبار 24 شهراً وتُؤخذ الدرجة الأعلى.{" "}
                  <a href="https://e-services.qiyas.sa/Qiyas.TRAS.Web.Internet/" target="_blank" rel="noopener noreferrer">
                    رابط حجز اختبار قياس
                  </a>
                </p>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <strong>عناصر الترجيح عند تساوي النقاط</strong>
              </div>
              <div className="info-section-body">
                <ol style={{ lineHeight: "1.8" }}>
                  <li>الأعلى في تقييم الأداء الوظيفي</li>
                  <li>الأقدم في تاريخ التعيين (يوم/شهر/سنة)</li>
                  <li>الأعلى في برامج التطوير والتدريب</li>
                  <li>الأقدم في تاريخ الحصول على المرتبة الحالية</li>
                  <li>المؤهل العلمي الأعلى</li>
                  <li>الأقدمية في تاريخ التعيين على السلم العام</li>
                  <li>الأقدمية في الحصول على المؤهل العلمي</li>
                </ol>
                <div className="alert alert-warning mt-3" style={{ fontSize: "14px" }}>
                  ⚠️ <strong>إخلاء مسؤولية:</strong> هذه الحاسبة أداة تقديرية للاستخدام الشخصي فقط. المرجع الرسمي هو{" "}
                  <a
                    href="https://www.moe.gov.sa/ar/aboutus/sectors/hr/Documents/987788888%D9%85%20%D8%AF.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    الوثيقة الرسمية لوزارة التعليم 2026م
                  </a>.
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminPromotionCalculator;
